
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const OpenFolder20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.5a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v2.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3H6Zm2.15 5.15A.5.5 0 0 1 8.5 8h4.99a.5.5 0 0 1 0 1H9.7l6.15 6.15a.5.5 0 0 1-.7.7L9 9.71v3.79a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .15-.35Z"
            fill="currentColor"
        />
    </svg>
}